/* eslint-disable import/prefer-default-export */
import { formatHex, parse } from 'culori';
import twColors from 'tailwindcss/colors';

import { MODEL_DEAL, MODEL_SERVICE_CALL, MODEL_TASK } from 'constants/models';

function twHex(color) {
  if (typeof color !== 'string') return color;
  if (!color.startsWith('oklch(')) return color;

  const parsed = parse(color);
  if (!parsed) return color;

  return formatHex(parsed);
}

/** Tailwind-backed model colors (Deal uses the same blue-600 as MUI primary). */
export const MODEL_NAME_COLORS = {
  [MODEL_DEAL]: twHex(twColors.blue[600]),
  [MODEL_SERVICE_CALL]: twHex(twColors.red[600]),
  [MODEL_TASK]: twHex(twColors.purple[600]),
};

export function getModelEventColor(
  model,
  primaryMain = MODEL_NAME_COLORS[MODEL_DEAL],
) {
  if (model === MODEL_SERVICE_CALL) {
    return MODEL_NAME_COLORS[MODEL_SERVICE_CALL];
  }

  if (model === MODEL_TASK) {
    return MODEL_NAME_COLORS[MODEL_TASK];
  }

  return primaryMain;
}
